import Svg from 'components/utilities/svg'
import { FC, SVGProps } from 'react'

const Lines: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <Svg fill="none" viewBox="0 0 180 139" {...props}>
    <path
      d="M0 18.5H114C117.314 18.5 120 21.1863 120 24.5C120 27.8137 117.314 30.5 114 30.5H0V18.5Z"
      fill="#959BB1"
    />
    <path
      d="M0 48.5H174C177.314 48.5 180 51.1863 180 54.5C180 57.8137 177.314 60.5 174 60.5H0V48.5Z"
      fill="#4D5168"
    />
    <path
      d="M0 78.5H114C117.314 78.5 120 81.1863 120 84.5C120 87.8137 117.314 90.5 114 90.5H0V78.5Z"
      fill="#6BB0B3"
    />
    <path
      d="M0 108.5H114C117.314 108.5 120 111.186 120 114.5C120 117.814 117.314 120.5 114 120.5H0V108.5Z"
      fill="#68B688"
    />
  </Svg>
)

export default Lines
